import React from 'react';
import Card from '../common/Card/Card';
import { useLocation, useParams } from 'react-router-dom';
import './AnalysesNavItem.css';

type Props = {
    icon: React.ReactNode;
    title: string;
    path: string;
};

const AnalysisNavItem = ({ icon, title, path }: Props) => {
    const { municipalitaId, bodyType, zastupitelstvoId } = useParams();

    const location = useLocation();
    const fullPath = `/${municipalitaId}/${bodyType}/${zastupitelstvoId}/analyzy/${path}`;
    const isSelected = location.pathname === fullPath;

    return (
        <Card
            link={`/${municipalitaId}/${bodyType}/${zastupitelstvoId}/analyzy/${path}`}
            className={`${isSelected ? 'active' : ''}`}
        >
            {icon}
            <h4>{title}</h4>
        </Card>
    );
};

export default AnalysisNavItem;
